import React from "react";
import { Link } from 'react-router-dom';
import { firestore, storage } from '../firebase.js';

function DashBoardInfo(props){
  const [userProfile, setUserProfile] = React.useState({});
  const [editProfile, setEditProfile] = React.useState(false);
  const [userAreaOfWork, setUserAreaOfWork] = React.useState([]);
  const [userServices, setUserServices] = React.useState([]);
  const [userAvailability, setUserAvailability] = React.useState([]);
  const [checkBoxStatus, setCheckBoxStatus] = React.useState({
    home: false,
    commercial: false,
    restaurant: false,
    industrial: false,
    project: false,
    events: false,
    specialty: false,
    other: false,
    offices: false,
    washrooms: false,
    kitchen: false,
    cafeteria: false,
    carpet: false,
    floorCare: false,
    window: false,
    serviceOther: false,
    mornings: false,
    evenings: false,
    days: false,
    nights: false,
    afternoons: false,
    weekends: false
  });

  React.useEffect(() => {
    getUserData();
  }, []);

  const getUserData = () => {
    firestore.collection('users').doc(props.user.uid).get()
      .then(res => {
        let userData = res.data();
        setUserProfile(userData);
        setUserAreaOfWork(userData.areaOfWork);
        setUserServices(userData.services);
        setUserAvailability(userData.availability);
        let checkBox = checkBoxStatus;
        userData.areaOfWork.includes('home') ? checkBox.home = true : checkBox.home = false;
        userData.areaOfWork.includes('commercial') ? checkBox.commercial = true : checkBox.commercial = false;
        userData.areaOfWork.includes('restaurant') ? checkBox.restaurant = true : checkBox.restaurant = false;
        userData.areaOfWork.includes('industrial') ? checkBox.industrial = true : checkBox.industrial = false;
        userData.areaOfWork.includes('project') ? checkBox.project = true : checkBox.project = false;
        userData.areaOfWork.includes('events') ? checkBox.events = true : checkBox.events = false;
        userData.areaOfWork.includes('specialty') ? checkBox.specialty = true : checkBox.specialty = false;
        userData.areaOfWork.includes('other') ? checkBox.other = true : checkBox.other = false;
        userData.services.includes('offices') ? checkBox.offices = true : checkBox.offices = false;
        userData.services.includes('washrooms') ? checkBox.washrooms = true : checkBox.washrooms = false;
        userData.services.includes('kitchen') ? checkBox.kitchen = true : checkBox.kitchen = false;
        userData.services.includes('cafeteria') ? checkBox.cafeteria = true : checkBox.cafeteria = false;
        userData.services.includes('carpet') ? checkBox.carpet = true : checkBox.carpet = false;
        userData.services.includes('floorCare') ? checkBox.floorCare = true : checkBox.floorCare = false;
        userData.services.includes('window') ? checkBox.window = true : checkBox.window = false;
        userData.services.includes('serviceOther') ? checkBox.serviceOther = true : checkBox.serviceOther = false;
        userData.availability.includes('mornings') ? checkBox.mornings = true : checkBox.mornings = false;
        userData.availability.includes('evenings') ? checkBox.evenings = true : checkBox.evenings = false;
        userData.availability.includes('days') ? checkBox.days = true : checkBox.days = false;
        userData.availability.includes('nights') ? checkBox.nights = true : checkBox.nights = false;
        userData.availability.includes('afternoons') ? checkBox.afternoons = true : checkBox.afternoons = false;
        userData.availability.includes('weekends') ? checkBox.weekends = true : checkBox.weekends = false;
        setCheckBoxStatus(checkBox);
      })
      .catch(err => {
        console.log(err);
      })
  }

  const clickCheckBox = (value) => {
    let checkBox = checkBoxStatus;
    let valueStatus = checkBox[value];
    checkBox[value] = !valueStatus;
    setCheckBoxStatus(checkBox);
    console.log(checkBoxStatus);
  }

  const submitJob = (e) => {
    e.preventDefault();
    firestore.collection('users').doc(props.user.uid).update({
      job: e.target.job.value
    })
      .then(res => {
        console.log(res);
        getUserData();
      })
      .catch(err => {
        console.log(err);
      })
  }

  const submitProfileChange = (e) => {
    e.preventDefault();
    //Area of Work
    let areaOfWork = [];
    e.target.home.checked && areaOfWork.push('home');
    e.target.commercial.checked && areaOfWork.push('commercial');
    e.target.restaurant.checked && areaOfWork.push('restaurant');
    e.target.industrial.checked && areaOfWork.push('industrial');
    e.target.projects.checked && areaOfWork.push('project');
    e.target.events.checked && areaOfWork.push('events');
    e.target.specialty.checked && areaOfWork.push('specialty');
    if (e.target.areaOfWorkOther.checked && e.target.otherDescription.value) {
      areaOfWork.push(e.target.otherDescription.value);
    } else if (e.target.areaOfWorkOther.checked && !e.target.otherDescription.value) {
      return;
    }
    //Services
    let serviceArray = [];
    e.target.offices.checked && serviceArray.push('offices');
    e.target.washrooms.checked && serviceArray.push('washrooms');
    e.target.kitchen.checked && serviceArray.push('kitchen');
    e.target.cafeteria.checked && serviceArray.push('cafeteria');
    e.target.carpet.checked && serviceArray.push('carpet');
    e.target.floorCare.checked && serviceArray.push('floorCare');
    e.target.window.checked && serviceArray.push('window');
    if (e.target.serviceOther.checked && e.target.serviceOtherDescription.value) {
      serviceArray.push(e.target.serviceOtherDescription.value);
    } else if (e.target.serviceOther.checked && !e.target.serviceOtherDescription.value) {
      return;
    }
    //Availability
    let availabilityArray = [];
    e.target.mornings.checked && availabilityArray.push('mornings');
    e.target.evenings.checked && availabilityArray.push('evenings');
    e.target.days.checked && availabilityArray.push('days');
    e.target.nights.checked && availabilityArray.push('nights');
    e.target.afternoons.checked && availabilityArray.push('afternoons');
    e.target.weekends.checked && availabilityArray.push('weekends');
    firestore.collection('users').doc(props.user.uid).update({
      province: e.target.province.value,
      city: e.target.city.value,
      postal: e.target.postalcode.value,
      areaOfWork: areaOfWork,
      services: serviceArray,
      rate: e.target.rate.value,
      headline: e.target.headline.value,
      description: e.target.description.value,
      supplies: e.target.supplies.value,
      equipment: e.target.equipment.value,
      availability: availabilityArray
    })
      .then(res => {
        console.log('success!!!!');
      })
  }

  return(
    <section>
      {
        userProfile.job === '' ?
          <form onSubmit={submitJob}>
            <h3>Are you a cleaner or employer?</h3>
            <p>*Warning: This cannot change</p>
            <input type="radio" name='job' value='cleaner' />
            <label htmlFor="job">Cleaner</label>
            <input type="radio" name='job' value='employer' />
            <label htmlFor="job">Employer</label>
            <button type='submit'>SUBMIT</button>
          </form> :
          <></>
      }
      {
        userProfile.job === 'cleaner' ?
          <button onClick={() => setEditProfile(!editProfile)}>EDIT PROFILE</button> :
          <></>
      }
      {
        userProfile.job === 'cleaner' && editProfile === true ?
          <form className='createjob' onSubmit={submitProfileChange}>
            {/*Location Section*/}
            <h3 className='createjob__subtitle'>Where are you applying for jobs?</h3>
            <label className='createjob__label' htmlFor="country">
              Country
            </label>
            <input
              className='createjob__textinput'
              name='country'
              type="text"
              defaultValue={userProfile.country}
            />
            <label className='createjob__label' htmlFor="province">
              Province/State
            </label>
            <input
              className='createjob__textinput'
              name='province'
              type="text"
              defaultValue={userProfile.province}
            />
            <label className='createjob__label' htmlFor="city">
              City
            </label>
            <input
              className='createjob__textinput'
              name='city'
              type="text"
              defaultValue={userProfile.city}
            />
            <label className='createjob__label' htmlFor="postalcode">
              Postal Code/ZIP Code
            </label>
            <input
              className='createjob__textinput'
              name='postalcode'
              type="text"
              defaultValue={userProfile.postal}
            />
            {/*Area of Work Section*/}
            <h3 className='createjob__subtitle'>Which job categories do you offer?</h3>
            <p className='createjob__desc'>Select all that apply.</p>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="home"
                defaultChecked={checkBoxStatus.home}
                onClick={() => clickCheckBox('home')}
              />
              <label className='createjob__label' htmlFor="home">Home</label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="commercial"
                defaultChecked={checkBoxStatus.commercial}
                onClick={() => clickCheckBox('commercial')}
              />
              <label className='createjob__label' htmlFor="commercial">
                Commercial
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="restaurant"
                defaultChecked={checkBoxStatus.restaurant}
                onClick={() => clickCheckBox('restaurant')}
              />
              <label className='createjob__label' htmlFor="restaurant">
                Restaurant
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="industrial"
                defaultChecked={checkBoxStatus.industrial}
                onClick={() => clickCheckBox('industrial')}
              />
              <label className='createjob__label' htmlFor="industrial">
                Industrial
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="projects"
                defaultChecked={checkBoxStatus.project}
                onClick={() => clickCheckBox('project')}
              />
              <label className='createjob__label' htmlFor="project">
                Projects
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="events"
                defaultChecked={checkBoxStatus.events}
                onClick={() => clickCheckBox('events')}
              />
              <label className='createjob__label' htmlFor="events">
                Events
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="specialty"
                defaultChecked={checkBoxStatus.specialty}
                onClick={() => clickCheckBox('specialty')}
              />
              <label className='createjob__label' htmlFor="specialty">
                Specialty (Winow Cleaning etc.)
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="areaOfWorkOther"
                defaultChecked={checkBoxStatus.other}
                onClick={() => clickCheckBox('other')}
              />
              <label className='createjob__label' htmlFor="other">
                Other
              </label>
            </div>
            <label className='createjob__label' htmlFor="otherDescription">
              Please Describe:
            </label>
            <input className='createjob__textinput' name='otherDescription' type="text" />
          {/*Services Section*/}
            <h3 className='createjob__subtitle'>Which services do you supply?</h3>
            <p className='createjob__desc'>Select all that apply.</p>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name='offices'
                defaultChecked={checkBoxStatus.offices}
                onClick={() => clickCheckBox('offices')}
              />
              <label className='createjob__label' htmlFor="offices">Offices</label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="washrooms"
                defaultChecked={checkBoxStatus.washrooms}
                onClick={() => clickCheckBox('washrooms')}
              />
              <label className='createjob__label' htmlFor="washrooms">
                Washrooms
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="kitchen"
                defaultChecked={checkBoxStatus.kitchen}
                onClick={() => clickCheckBox('kitchen')}
              />
              <label className='createjob__label' htmlFor="kitchen">
                Kitchen
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="cafeteria"
                defaultChecked={checkBoxStatus.cafeteria}
                onClick={() => clickCheckBox('cafeteria')}
              />
              <label className='createjob__label' htmlFor="cafeteria">
                Cafeteria
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="carpet"
                defaultChecked={checkBoxStatus.carpet}
                onClick={() => clickCheckBox('carpet')}
              />
              <label className='createjob__label' htmlFor="carpet">
                Carpet
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="floorCare"
                defaultChecked={checkBoxStatus.floorCare}
                onClick={() => clickCheckBox('floorCare')}
              />
              <label className='createjob__label' htmlFor="floorCare">
                Floor Care
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="window"
                defaultChecked={checkBoxStatus.window}
                onClick={() => clickCheckBox('window')}
              />
              <label className='createjob__label' htmlFor="window">
                Window
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="serviceOther"
                defaultChecked={checkBoxStatus.other}
                onClick={() => clickCheckBox('other')}
              />
              <label className='createjob__label' htmlFor="other">
                Other
              </label>
            </div>
            <label className='createjob__label' htmlFor="serviceOtherDescription">
              Please Describe:
            </label>
            <input className='createjob__textinput' name='serviceOtherDescription' type="text" />
            {/*Rate Section*/}
            <h3 className='createjob__subtitle'>What rate do you charge?</h3>
            <label className='createjob__label' htmlFor="rate">
              Must be minimum $16 an hour
            </label>
            <input
              className='createjob__textinput'
              name='rate'
              type="number"
              defaultValue={userProfile.rate}
            />
            {/*Description Section*/}
            <h3 className='createjob__subtitle'>What should employers know about the job?</h3>
            <label className='createjob__label' htmlFor="headline">
              Headline
            </label>
            <input
              className='createjob__textinput'
              name='headline'
              type="text"
              defaultValue={userProfile.headline}
            />
            <label className='createjob__label' htmlFor="description">
              Description of Services
            </label>
            <textarea
              className='createjob__input--area'
              name="description"
              defaultValue={userProfile.description}
            ></textarea>
            {/*<label className='createjob__label' htmlFor="service">
              Service Requirements
            </label>
            <textarea className='createjob__input--area' name="service"></textarea>*/}
            {/*Supplies Section*/}
            <h4 className='createjob__subtitle createjob__subtitle--small'>
              Do you own your own cleaning supplies and equipment?
            </h4>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__radioinput'
                type="radio"
                name="supplies"
                value={true}
                defaultChecked={
                  userProfile.supplies === 'true' ?
                    true :
                    false
                }
                required
              />
              <label className='createjob__label' htmlFor="supplies">
                I own cleaning supplies
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__radioinput'
                type="radio"
                name='supplies'
                value={false}
                defaultChecked={
                  userProfile.supplies === 'false' ?
                    true :
                    false
                }
                required
              />
              <label className='createjob__label' htmlFor="supplies">
                I do not own cleaning supplies
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__radioinput'
                type="radio"
                name="equipment"
                value={true}
                defaultChecked={
                  userProfile.equipment === 'true' ?
                    true :
                    false
                }
                required
              />
              <label className='createjob__label' htmlFor="equipment">
                I own cleaning equipment
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__radioinput'
                type="radio"
                name="equipment"
                value={false}
                defaultChecked={
                  userProfile.equipment === 'false' ?
                    true :
                    false
                }
                required
              />
              <label className='createjob__label' htmlFor="equipment">
                I do not own cleaning equipment
              </label>
            </div>
            {/*Availability Section*/}
            <h4 className='createjob__subtitle createjob__subtitle--small'>
              What is your availability?
            </h4>
            <p className='createjob__desc'>Select all that apply</p>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="mornings"
                defaultChecked={checkBoxStatus.mornings}
                onClick={() => clickCheckBox('mornings')}
              />
              <label className='createjob__label' htmlFor="mornings">
                Mornings
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="evenings"
                defaultChecked={checkBoxStatus.evenings}
                onClick={() => clickCheckBox('evenings')}
              />
              <label className='createjob__label' htmlFor="evenings">
                Evenings
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="days"
                defaultChecked={checkBoxStatus.days}
                onClick={() => clickCheckBox('days')}
              />
              <label className='createjob__label' htmlFor="days">
                Days
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="nights"
                defaultChecked={checkBoxStatus.nights}
                onClick={() => clickCheckBox('nights')}
              />
              <label className='createjob__label' htmlFor="nights">
                Nights
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="afternoons"
                defaultChecked={checkBoxStatus.afternoons}
                onClick={() => clickCheckBox('afternoons')}
              />
              <label className='createjob__label' htmlFor="afternoons">
                Afternoons
              </label>
            </div>
            <div className='createjob__checkContainer'>
              <input
                className='createjob__checkinput'
                type="checkbox"
                name="weekends"
                defaultChecked={checkBoxStatus.weekends}
                onClick={() => clickCheckBox('weekends')}
              />
              <label className='createjob__label' htmlFor="weekends">
                Weekends
              </label>
            </div>
            {/*Photos Section*/}

            <button type='submit'>SUBMIT</button>
          </form>:
          <></>
      }
      {
        userProfile.job === 'employer' ?
          <Link to='/jobform'>CREATE JOB</Link> :
          <></>
      }
    </section>
  );
}

export default DashBoardInfo;